module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row10_picture.381de6c7.png";